import { render, staticRenderFns } from "./list-show.vue?vue&type=template&id=a53cedea&scoped=true&"
import script from "./list-show.vue?vue&type=script&lang=js&"
export * from "./list-show.vue?vue&type=script&lang=js&"
import style0 from "./list-show.vue?vue&type=style&index=0&id=a53cedea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53cedea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53cedea')) {
      api.createRecord('a53cedea', component.options)
    } else {
      api.reload('a53cedea', component.options)
    }
    module.hot.accept("./list-show.vue?vue&type=template&id=a53cedea&scoped=true&", function () {
      api.rerender('a53cedea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/form/list-show.vue"
export default component.exports